import React, { useEffect, useState } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../components/button/button";
import Intro from "./intro";
import { useSubscriptionFormik } from "./formik";
import Event from "../../../../../../core/consts/analytics-events";
import styles from "./cancel-modal.module.scss";
import NavBar from "../../../../../../components/nav-bar/nav-bar";
import Modal from "../../../../../../components/modal/modal";
import { useDI } from "../../../../../../core/di";

const options = [
  "priceTooHigh",
  "didntUseIt",
  "experiencedTechnicalDifficulties",
  "stoppedDriving",
];

interface Props {
  onClose: () => void;
  onCancelSubscription: ({ cause }: { cause: string }) => void;
}

export function CancelModal(props: Props) {
  const { onCancelSubscription, onClose } = props;
  const [loading, setLoading] = useState(false);
  const formik = useSubscriptionFormik();
  const { t } = useTranslation();
  const { analytics } = useDI();

  useEffect(() => {
    analytics?.track(Event.CancelSubscriptionViewed);
  }, []);

  const handleCancel = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await onCancelSubscription({ cause: formik.values.cause });
    setLoading(false);
  };

  const handleChange = (e: any) => {
    const cause = e.target.value;
    analytics?.track(Event.CancelSubscriptionReasonClicked, { cause });
    formik.handleChange(e);
  };

  const renderOptions = () => {
    return (
      <RadioGroup name="cancel-radio-buttons-group">
        {options.map((option, index) => (
          <FormControlLabel
            key={option}
            name="cause"
            labelPlacement="end"
            value={option}
            control={<Radio className={styles.Radio} />}
            // @ts-ignore
            label={t(option) as string}
            className={clsx(
              styles.FormControlLabel,
              index === 0 && styles.First
            )}
            onChange={handleChange}
          />
        ))}
      </RadioGroup>
    );
  };

  const footer = () => {
    const handleDontCancelBtnClick = () => {
      analytics?.track(Event.CancelSubscriptionDontCancelClicked);
      onClose();
    };

    return (
      <footer className={styles.Footer}>
        <Button submit={true} disabled={!formik.isValid} loading={loading}>
          {t("yesCancelSubscription")}
        </Button>
        <Button action={handleDontCancelBtnClick} alt={true}>
          {t("dontCancelSubscription")}
        </Button>
      </footer>
    );
  };

  const intro = () => {
    return (
      <div className={styles.Intro}>
        <Intro />
      </div>
    );
  };

  const handleNavCloseClick = () => {
    analytics?.track(Event.CancelSubscriptionXClicked);
    onClose();
  };

  return (
    <Modal
      fullWidth={true}
      title={t("cancelSubscription")}
      data-testid={"cancel-subscription"}
      navBar={<NavBar mode={"close"} onClick={handleNavCloseClick} />}
    >
      {intro()}
      <form action={"#"} onSubmit={handleCancel}>
        <h3 className={styles.Question}>{t("whyDoYouWantToCancel")}</h3>
        <div className={styles.Fields}>{renderOptions()}</div>
        <p className={styles.Note}>
          {t("ifYouCancelYouWillImmediatelyLoseAccess")}
        </p>
        {footer()}
      </form>
    </Modal>
  );
}

export default CancelModal;
